import { observable, action, computed } from 'mobx';
import { setter } from 'mobx-decorators';
import agent from '../../services/web/agent';
import erorrHandler from '../../services/web/erorrHandler';
import { AdditionalUserDnTooltip } from '../../components/ldap/forms/ldapHelpTooltipContent';

class LdapTeamMappingStore {

    @setter @observable ldapTeamMappings;
    @setter @observable ldapServerMappings;

    @setter @observable getLdapTeamMappingsProgress;
    @setter @observable getLdapServerMappingsProgress;
    @setter @observable putLdapTeamMappingsProgress;
    @setter @observable deleteLdapTeamMappingsProgress;

    @setter @observable getLdapTeamMappingsErrorMessage;
    @setter @observable getLdapServerMappingsErrorMessage;
    @setter @observable putLdapTeamMappingsErrorMessage;
    @setter @observable deleteLdapTeamMappingsErrorMessage;

    @action getByTeamId(teamId) {

        this.getLdapTeamMappingsProgress = true;

        return agent.LDAPTeamMappings.get({
                teamId: teamId
            })
            .then(action((ldapTeamMappings) => {
                
                return this.ldapTeamMappings = ldapTeamMappings;
            }))
            .catch(action((err) => {

                this.getLdapTeamMappingsErrorMessage = erorrHandler.getErrorMessage(err);
        
                throw err;
            }))
            .finally(action(() => {
                this.getLdapTeamMappingsProgress = false;
            }));
    }

    @action getByServerId(ldapServerId) {

        this.getLdapServerMappingsProgress = true;

        return agent.LDAPTeamMappings.get({
                ldapServerId: ldapServerId
            })
            .then(action((ldapServerMappings) => {
                
                return this.ldapServerMappings = ldapServerMappings;
            }))
            .catch(action((err) => {

                this.getLdapServerMappingsErrorMessage = erorrHandler.getErrorMessage(err);
        
                throw err;
            }))
            .finally(action(() => {
                this.getLdapServerMappingsProgress = false;
            }));
    }

    @action put(ldapServerId, data) {

        this.putLdapTeamMappingsProgress = true;

        return agent.LDAPTeamMappings.put(ldapServerId, data)
            .then(action(() => {
                //
            }))
            .catch(action((err) => {

                this.putLdapTeamMappingsErrorMessage = erorrHandler.getErrorMessage(err);

                throw err;
            }))
            .finally(action(() => {
                this.putLdapTeamMappingsProgress = false;
            }));
    }

    @action delete(ldapTeamMappingId) {

        this.deleteLdapTeamMappingsProgress = true;

        return agent.LDAPTeamMappings.delete(ldapTeamMappingId)
            .then(action(() => {
                //
            }))
            .catch(action((err) => {

                this.deleteLdapTeamMappingsErrorMessage = erorrHandler.getErrorMessage(err);

                throw err;
            }))
            .finally(action(() => {
                this.deleteLdapTeamMappingsProgress = false;
            }));
    }
}

export default new LdapTeamMappingStore();